"use strict";

if (typeof CountryCodes == 'undefined') var CountryCodes = {

    // source of country-codes.json
    // http://data.okfn.org/data/core/country-codes/r/country-codes.json
    getCountry: function(countryCode, callback) {
        CountryCodes.load(function(data) {
            var countries = _(data).filter(function(entry) { return entry['ISO3166-1-Alpha-2'] == countryCode.toUpperCase(); });
            if (countries.length == 1) {
                if (callback) callback(countries[0]);
            } else
                console.error(countries.length, 'matches for', countryCode);
        });
    },

    load: function(callback) {
        if (CountryCodes.data) {
            if (callback) callback(CountryCodes.data);
        } else {
            $.getJSON('/raw/country-codes.json', function (data) {
                CountryCodes.data = data;
                if (callback) callback(data);
            });
        }
    },


    european: [ "ad","al","at","ba","be","bg","by","ch","cy","cz","de","dk","ee","es","fi","fo","fr","gg","gi","gr","hr","hu","ie","im","is","it","je","li","lt","lu","lv","mc","md","mk","mt","nl","no","pl","pt","ro","ru","se","si","sj","sk","sm","tr","ua","uk","va","yu", "gb" ],
    eu: [ "be", "bg", "cz", "dk", "de", "ee", "ie", "el", "es", "fr", "hr", "it", "cy", "lv", "lt", "lu", "hu", "mt", "nl", "at", "pl", "pt", "ro", "si", "sk", "fi", "se", "uk", "gb" ],

};

